import React, { useMemo, useState } from 'react';
import { useMapCanvas } from '../../contexts/MapCanvasContext';
import { ShapeOptions, ShapeState } from './ShapeProvider.types';

export const ShapeContext = React.createContext<ShapeState | null>(null);

export const ShapeProvider: React.FC<React.PropsWithChildren<ShapeOptions>> = ({
  children,
  shape,
  isSelected,
  isInSelection,
  onSelect,
  onUpdate,
  isGroupChild,
  parentGroupColor,
  editorConfigRef,
  otherShapes,
  disabled,
  isMultiSelected,
  onDelete,
  onLocate,
  onMoveUp,
  onMoveDown,
  selectIndex
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [snapLines, setSnapLines] = useState<ShapeState["snapLines"]>({});
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  const { isViewMode } = useMapCanvas();

  if (isViewMode) shape.locked = false;

  const value = useMemo<ShapeState>(
    () => ({
      shape,
      isSelected,
      isInSelection,
      onSelect,
      onUpdate,
      isGroupChild,
      parentGroupColor,
      editorConfigRef,
      otherShapes,
      disabled,
      isMultiSelected,
      onDelete,
      onLocate,
      onMoveUp,
      onMoveDown,
      selectIndex,
      isHovered,
      isEditing,
      snapLines,
      image,
      setIsHovered,
      setIsEditing,
      setSnapLines,
      setImage
    }),
    [
      shape, isSelected, isInSelection, onSelect, onUpdate, isGroupChild,
      parentGroupColor, otherShapes, disabled,
      isMultiSelected, onDelete, onLocate, onMoveUp, onMoveDown, selectIndex,
      isHovered, isEditing, snapLines, image
    ]
  );

  return (
    <ShapeContext.Provider value={value}>
      {children}
    </ShapeContext.Provider>
  );
};
